import type { ChatPanelHeaderProps } from '@halo/ui-chat-react';
import { ChatPanelHeader } from '@halo/ui-chat-react';
import { useShallowEnhance } from '@halo/zustand-enhance';
import type { SessionStore } from '@/store/client';
import { SessionsStatus, useAppStore } from '@/store/client';
import { useSessionStore } from '@/store/session';

export interface SessionHeaderProps
  extends Omit<
    ChatPanelHeaderProps,
    'avatar' | 'sessionName' | 'username' | 'state' | 'name' | 'memberCount'
  > {
  sessionStore: SessionStore;
}

export function SessionHeader({ sessionStore, isGroup, ...props }: SessionHeaderProps) {
  const { user, sessionsStatus } = useAppStore(useShallowEnhance(['user', 'sessionsStatus']));

  const { connecting } = useSessionStore();

  return (
    <ChatPanelHeader
      duration={sessionStore?.session?.expire_duration}
      connecting={connecting}
      show={!!user?.username && sessionsStatus > SessionsStatus.LOADING}
      avatar={isGroup ? sessionStore?.session?.avatar : sessionStore.singleUser?.avatar}
      sessionName={(isGroup ? sessionStore?.session?.name : sessionStore.singleUser?.name) || ''}
      username={sessionStore?.singleUser?.username || ''}
      secondaryName={sessionStore?.singleUser?.secondary_name || ''}
      state={sessionStore?.session?.user_info?.state}
      memberCount={sessionStore?.groupInfo?.member_num || 0}
      isGroup={isGroup}
      {...props}
    />
  );
}
